// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1gLwS","inner":"Form_inner__3eHjO","range":"Form_range__1x9Bd","name":"Form_name__2FawR","actions":"Form_actions__1ngG-"};